import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Offers'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Offers'

export const mediaPlatformOffersRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.OFFERS,
  loader: () => ({
    crumb: t('entity:publishing.offer', { count: 2 }),
  }),
})

export const mediaPlatformOffersLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformOffersRoute,
  id: 'mediaPlatformOffersLayout',
  component: Structure,
})

type MediaPlatformOffersOverviewSearch = {
  query?: string
}

export const mediaPlatformOffersOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformOffersLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformOffersOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
